import {Injectable, Inject} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {SigninService} from "./signin.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    @Inject("signin") private signin: SigninService,
    private router: Router
  ){

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (this.signin.session){
      //this.router.navigate(['dashboard']);
    } else {
      //this.router.navigate(['login']);
    }
    return this.signin.session;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.guard.ts